import React, { useState, useContext, useEffect } from "react";
import { StoreContext } from "../../context/store/storeContext";
import MegaMenu from "../menu/mega_menu/MegaMenu";
import EntryDialog from "../dialog/EntryDialog";
import { Layout, Menu, Drawer, Dropdown, Modal } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useCookies } from "react-cookie";
import { useHistory, Link, useLocation } from "react-router-dom";
import {
  BROWSE_CAR,
  EASYLEASE,
  HOWITWORKS,
  SIGNIN,
  SIGNUP,
  SOLUTION_FOR_BUSINESS,
} from "../../route/AppRouter";
import ProfileImage from "../ProfileImage";
import Logo from "../Logo";
import { megaMenuSerivice } from "../menu/mega_menu/MegaMenuSerivce";
const { Header } = Layout;

const NavLinks = [
  {
    name: "Find a car",
    to: BROWSE_CAR,
  },
  {
    name: "What's Easy Lease",
    to: EASYLEASE,
  },
  {
    name: "How it works",
    to: HOWITWORKS,
  },
  {
    name: "Personal",
    to: BROWSE_CAR,
  },
  {
    name: "Business",
    to: SOLUTION_FOR_BUSINESS,
  },
];

const AppHeader = () => {
  const { state, actions } = useContext(StoreContext);
  const { dialogState } = state;
  const [menu, handleOpenMegaMenu] = useState({ open: false, type: "lease" });
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [cookies, removeCookie] = useCookies("SESSION");
  const history = useHistory();
  const location = useLocation();
  const closeMegaMenu = () => {
    handleOpenMegaMenu({ open: false, type: "lease" });
  };

  useEffect(() => {
    megaMenuSerivice.handleOpen().subscribe((open) => {
      handleOpenMegaMenu({ ...menu, open: open });
    });
  }, [menu]);

  useEffect(() => {
    if (location?.pathname === SIGNIN) {
      actions.dialogAction.openEntryDialog({ open: true, type: "signin" });
    }
    if (location?.pathname === SIGNUP) {
      actions.dialogAction.openEntryDialog({ open: true, type: "signup" });
    }
  }, []);

  const handleRedirectHome = () => {
    history.push("/");
  };
  const profileSubMenu = (
    <Menu className="profileDropdownMenu">
      <Menu.Item>
        <Link to={{ pathname: "/profile/detail", state: { index: 0 } }}>
          Profile
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link to="/subscriptions?status=current">Subscriptions</Link>
      </Menu.Item>
      <Menu.Item onClick={() => logout()}>
        <Link to="">Logout</Link>
      </Menu.Item>
    </Menu>
  );

  const logout = () => {
    Modal.confirm({
      title: "Logout",
      content: "Are you sure want to logout?",
      onOk: () => {
        removeCookie("SESSION", {
          path: "/",
        });
        history.push("/");
        window.location.reload(false);
      },
    });
  };

  return (
    <nav id="appHeader">
      <Header className="app-header">
        <Logo redirectHome={handleRedirectHome} />
        <Menu
          className="app-menu"
          theme="light"
          mode="horizontal"
          defaultSelectedKeys={[""]}
          style={{ lineHeight: "64px" }}
        >
          {NavLinks.map((item) => (
            <Menu.Item className={"app-menu-item"} key={item.name}>
              <Link to={item.to}>{item.name}</Link>
            </Menu.Item>
          ))}

          {cookies?.SESSION === undefined ? (
            <Menu.Item
              test_id="signin"
              className="app-menu-item signin-item"
              key="4"
              onClick={() =>
                actions.dialogAction.openEntryDialog({
                  open: true,
                  type: "signin",
                })
              }
            >
              {"LOGIN"}
            </Menu.Item>
          ) : (
            [
              cookies?.SESSION?.access_token === undefined ? (
                <Menu.Item
                  className="app-menu-item signin-item"
                  key="4"
                  onClick={() =>
                    actions.dialogAction.openEntryDialog({
                      open: true,
                      type: "signin",
                    })
                  }
                >
                  {"LOGIN"}
                </Menu.Item>
              ) : (
                <Menu.Item className="app-menu-item" key="5">
                  <Dropdown overlay={profileSubMenu} placement="bottomRight">
                    <span
                      className="ant-dropdown-link"
                      onClick={(e) => e.preventDefault()}
                    >
                      <div className="menuProfilePic">
                        <ProfileImage allowedEdit={false} />
                      </div>
                    </span>
                  </Dropdown>
                </Menu.Item>
              ),
            ]
          )}
        </Menu>
        <MenuOutlined
          className="drawer-button"
          style={{ fontSize: 30 }}
          onClick={() => setDrawerOpen(true)}
        />
        <ResponsiveMenu
          cookies={cookies}
          open={isDrawerOpen}
          handleOpenMegaMenu={handleOpenMegaMenu}
          setDrawerOpen={setDrawerOpen}
          logout={logout}
        />
      </Header>
      <MegaMenu type={menu.type} open={menu.open} closeDialog={closeMegaMenu} />
      <EntryDialog
        type={dialogState.type}
        open={dialogState.open_entry_dialog}
        onClose={actions.dialogAction.openEntryDialog}
      />
    </nav>
  );
};

const ResponsiveMenu = ({
  cookies,
  open,
  handleOpenMegaMenu,
  setDrawerOpen,
  logout,
}) => {
  const { state, actions } = useContext(StoreContext);

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const onClickLogin = () => {
    setDrawerOpen(false);
    actions.dialogAction.openEntryDialog({ open: true, type: "signin" });
  };

  return (
    <Drawer
      title=""
      placement="right"
      closable={false}
      onClose={() => setDrawerOpen(false)}
      visible={open}
    >
      <Menu
        className="drawer-menu"
        theme="light"
        mode="inline"
        defaultSelectedKeys={[""]}
        style={{ lineHeight: "64px" }}
      >
        {NavLinks.map((item) => (
          <Menu.Item
            className={"app-menu-item"}
            key={item.name}
            onClick={closeDrawer}
          >
            <Link to={item.to}>{item.name}</Link>
          </Menu.Item>
        ))}
        {cookies.SESSION === undefined ? (
          <Menu.Item className="app-menu-item" key="4" onClick={onClickLogin}>
            {"Login"}
          </Menu.Item>
        ) : (
          [
            cookies.SESSION.access_token === undefined ? (
              <Menu.Item
                className="app-menu-item"
                key="4"
                // onClick={() => handleOpenEntryDialog(true)}
                onClick={onClickLogin}
              >
                {"Login"}
              </Menu.Item>
            ) : (
              <Menu.SubMenu
                className="app-menu-item"
                key="5"
                title={
                  <span>
                    {/* <UserOutlined /> */}
                    <span>Profile</span>
                  </span>
                }
              >
                <Menu.Item key="6">
                  <Link
                    to={{ pathname: "/profile/detail", state: { index: 0 } }}
                  >
                    Profile
                  </Link>
                </Menu.Item>
                <Menu.Item key="7">
                  <Link
                    to={{ pathname: "/profile/detail", state: { index: 1 } }}
                  >
                    Subscriptions
                  </Link>
                </Menu.Item>
                <Menu.Item key="8" onClick={() => logout()}>
                  Logout
                </Menu.Item>
              </Menu.SubMenu>
            ),
          ]
        )}
      </Menu>
    </Drawer>
  );
};

export default AppHeader;
